export const TASK_TYPE = "taskType";
export const TASK_NAME = "taskName";
export const ASSIGNEE = "assignee";
export const CATEGORY = "category";
export const STATUS = "status";
export const URGENT = "urgent";
export const DUE_DATE = "dueDate";
export const CONSULT_ID = "consultId";
export const NOT_CONSULT_RELATED = "notConsultRelated";
export const MEMBER = "member";
export const GROUP = "group";
export const PROVIDER = "provider";
export const CHECKLIST = "checklist";
export const NOTES = "notes";
